import CartDetailComponent from "./CartDetail.Component";

export default CartDetailComponent;
